(() => {
  if (window.SunlitUpsellCardLoaded) return;
  window.SunlitUpsellCardLoaded = true;

  const moneySafeMessage = 'Could not add it right now. Please refresh and try again.';
  let cleanupInProgress = false;
  let cleanupTimer = null;

  function getCartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.dataset.sectionId)
      .filter(Boolean)
      .filter((value, index, array) => array.indexOf(value) === index);
  }

  function isUpsellItem(item) {
    const properties = item && item.properties ? item.properties : {};
    const source = properties['Added from'] || properties._sunlit_upsell || properties['_Sunlit upsell source'] || '';
    return typeof source === 'string' && source.toLowerCase().includes('upsell');
  }

  function showCartNotice(text) {
    if (!text) return;
    const drawer = document.querySelector('cart-drawer-component, .cart-drawer');
    const target = drawer?.querySelector('.cart-drawer__content, cart-items-component') || document.querySelector('cart-items-component');
    if (!target) return;
    let notice = target.querySelector('.sunlit-upsell-cart-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'sunlit-upsell-cart-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      target.insertBefore(notice, target.firstElementChild?.nextSibling || target.firstChild);
    }
    notice.textContent = text;
    window.clearTimeout(showCartNotice._timer);
    showCartNotice._timer = window.setTimeout(() => {
      if (notice && notice.parentNode) notice.remove();
    }, 5500);
  }


  function shuffleUpsellLists() {
    document.querySelectorAll('[data-sunlit-upsell-list]').forEach((list) => {
      if (list.dataset.shuffled === 'true') return;
      const scroller = list.querySelector('.sunlit-upsell-list__scroller');
      if (!scroller) return;
      const cards = Array.from(scroller.querySelectorAll('sunlit-upsell-card'));
      for (let index = cards.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[swapIndex]] = [cards[swapIndex], cards[index]];
      }
      cards.forEach((card) => scroller.appendChild(card));
      list.dataset.shuffled = 'true';
    });
  }

  function updateUpsellButtonStates(cart) {
    const items = cart && Array.isArray(cart.items) ? cart.items : [];
    const variantIds = new Set(items.map((item) => String(item.variant_id)));
    document.querySelectorAll('sunlit-upsell-card[data-variant-id]').forEach((card) => {
      const button = card.querySelector('[data-sunlit-upsell-add]');
      if (!button) return;
      if (variantIds.has(String(card.dataset.variantId))) {
        setButtonState(card, 'added');
      } else {
        button.removeAttribute('aria-disabled');
        setButtonState(card, 'default');
        setMessage(card, '');
      }
    });
  }

  async function syncUpsellButtons() {
    try {
      updateUpsellButtonStates(await fetchCart());
    } catch (error) {
      console.warn('Sunlit upsell state sync skipped:', error);
    }
  }

  function setButtonState(card, state) {
    const button = card.querySelector('[data-sunlit-upsell-add]');
    if (!button) return;
    const defaultLabel = button.querySelector('[data-label-default]');
    const loadingLabel = button.querySelector('[data-label-loading]');
    const addedLabel = button.querySelector('[data-label-added]');

    button.disabled = state === 'loading' || state === 'added';
    if (defaultLabel) defaultLabel.hidden = state !== 'default';
    if (loadingLabel) loadingLabel.hidden = state !== 'loading';
    if (addedLabel) addedLabel.hidden = state !== 'added';
    card.classList.toggle('is-added', state === 'added');
  }

  function setMessage(card, text, isError = false) {
    const message = card.querySelector('[data-sunlit-upsell-message]');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', Boolean(isError));
  }

  function isCartDrawerOpen() {
    return Boolean(document.querySelector('cart-drawer-component dialog[open], .cart-drawer dialog[open]'));
  }

  function refreshCartSections(parsedResponse, variantId) {
    const sections = parsedResponse && parsedResponse.sections ? parsedResponse.sections : {};
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: parsedResponse,
          data: {
            source: 'sunlit-upsell',
            variantId: variantId ? String(variantId) : undefined,
            itemCount: parsedResponse && parsedResponse.item_count,
            sections,
          },
        },
      })
    );
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Could not read cart.');
    return response.json();
  }

  async function applyDiscountCode(code) {
    const cleanCode = String(code || '').trim();
    if (!cleanCode) return false;
    try {
      await fetch(`/discount/${encodeURIComponent(cleanCode)}?redirect=/cart`, {
        credentials: 'same-origin',
        cache: 'no-store',
      });
      return true;
    } catch (error) {
      console.warn('Sunlit upsell discount could not be applied:', error);
      return false;
    }
  }

  async function fetchFreshCartSections(sectionIds) {
    if (!sectionIds || !sectionIds.length) return {};
    const response = await fetch(`/cart?sections=${encodeURIComponent(sectionIds.join(','))}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) return {};
    return response.json().catch(() => ({}));
  }

  async function changeLine(key, quantity, includeSections = true) {
    const payload = { id: key, quantity };
    const sectionIds = getCartSectionIds();
    if (includeSections && sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const parsed = await response.json().catch(() => ({}));
    if (!response.ok || parsed.status >= 400) {
      throw new Error(parsed.description || parsed.message || moneySafeMessage);
    }
    return parsed;
  }

  async function cleanupLonelyUpsells() {
    if (cleanupInProgress) return;
    cleanupInProgress = true;
    try {
      const cart = await fetchCart();
      const items = cart.items || [];
      const upsells = items.filter(isUpsellItem);
      const normalItems = items.filter((item) => !isUpsellItem(item));

      if (!upsells.length || normalItems.length > 0) return;

      let latestCart = null;
      for (let index = 0; index < upsells.length; index += 1) {
        latestCart = await changeLine(upsells[index].key, 0, index === upsells.length - 1);
      }
      if (latestCart) {
        refreshCartSections(latestCart);
        window.setTimeout(() => showCartNotice('Add-ons need one main item in your cart, so we removed the offer item.'), 80);
      }
    } catch (error) {
      console.warn('Sunlit upsell cleanup skipped:', error);
    } finally {
      cleanupInProgress = false;
    }
  }

  function scheduleCleanup(delay = 700) {
    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(cleanupLonelyUpsells, delay);
  }

  async function addUpsell(card) {
    const variantId = card.dataset.variantId;
    const button = card.querySelector('[data-sunlit-upsell-add]');
    if (!variantId || !button) return;

    setButtonState(card, 'loading');
    setMessage(card, '');

    const sectionIds = getCartSectionIds();
    const payload = {
      id: Number(variantId),
      quantity: 1,
      properties: {
        Offer: 'Add-on',
        '_Sunlit upsell source': card.dataset.source === 'cart-drawer' ? 'Cart drawer upsell' : 'Product page upsell',
        _sunlit_upsell: card.dataset.source === 'cart-drawer' ? 'cart-drawer-upsell' : 'product-page-upsell',
      },
    };

    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
      payload.sections_url = window.location.pathname;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const responseText = await response.text();
    let parsedResponse = {};
    try {
      parsedResponse = responseText ? JSON.parse(responseText) : {};
    } catch (error) {
      parsedResponse = {};
    }

    if (!response.ok || parsedResponse.status >= 400) {
      throw new Error(parsedResponse.description || parsedResponse.message || moneySafeMessage);
    }

    const discountApplied = await applyDiscountCode(card.dataset.discountCode);
    if (discountApplied && sectionIds.length) {
      const freshSections = await fetchFreshCartSections(sectionIds);
      if (freshSections && Object.keys(freshSections).length) {
        parsedResponse.sections = freshSections;
      }
    }

    button.setAttribute('aria-disabled', 'true');
    setButtonState(card, 'added');
    setMessage(card, 'Added.');
    refreshCartSections(parsedResponse, variantId);

  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sunlit-upsell-add]');
    if (!button) {
      if (event.target.closest('cart-items-component, cart-drawer-component, .cart-drawer')) scheduleCleanup(900);
      return;
    }

    const card = button.closest('sunlit-upsell-card');
    if (!card || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    try {
      await addUpsell(card);
    } catch (error) {
      console.error(error);
      setButtonState(card, 'default');
      setMessage(card, error.message || moneySafeMessage, true);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('cart-items-component, cart-drawer-component, .cart-drawer')) scheduleCleanup(900);
  });

  document.addEventListener('cart:update', (event) => {
    window.setTimeout(syncUpsellButtons, 250);
    if (event.detail && event.detail.data && event.detail.data.source === 'sunlit-upsell') return;
    if (!isCartDrawerOpen()) return;
    scheduleCleanup(900);
  });

  function initUpsells() {
    shuffleUpsellLists();
    syncUpsellButtons();
    if (isCartDrawerOpen()) scheduleCleanup(900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsells, { once: true });
  } else {
    initUpsells();
  }
})();
